import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import config from "config";

const TOP_PAGE_NUMBER = 10;

export const ReactGetInboxContacts = async ({
  currentPage,
  setContactList,
  setContactsQuantity,
}) => {
  const parameters = { TopPage: TOP_PAGE_NUMBER, PageNumber: currentPage };
  const response = await apiRequest(
    "ContactsLists",
    "ReactGetInboxContacts",
    parameters
  );
  if (response.status === "success") {
    setContactsQuantity(response.data?.ContactsQuantity || 0);
    setContactList(response.data?.ContactsList || []);
  }
};

export const CreateUserContact = async ({
  formBody,
  setContactList,
  setContactsQuantity,
  setCurrentPage,
}) => {
  const body = {
    ContactListId: 0,
    ContactListFullName: formBody.ContactName,
    ContactListEmail: formBody.Email,
    ContactListPhone: formBody.PhoneNumber,
    ContactListFavorite: formBody.ContactListFavorite,
    ContactListType: "",
    RecaptchaResponse: formBody.recaptchaResponse,
  };
  const response = await apiRequest(
    "ContactsLists",
    "CreateUserContactReact",
    body,
    "POST"
  );
  if (response.status === "success") {
    ReactGetInboxContacts({
      currentPage: 1,
      setContactList,
      setContactsQuantity,
    });
    setCurrentPage(1);
  }
  return response;
};

export const ReactUpdateContact = async ({
  formBody,
  setContactList,
  contactList,
}) => {
  const body = {
    ContactListId: formBody.contactListId,
    ContactListFullName: formBody.ContactName,
    ContactListEmail: formBody.Email,
    ContactListPhone: formBody.PhoneNumber,
    ContactListType: "",
    ContactListFavorite: formBody.ContactListFavorite,
    RecaptchaResponse: formBody.recaptchaResponse,
  };
  const response = await apiRequest(
    "ContactsLists",
    "UpdateUserContactReact",
    body,
    "POST"
  );
  if (response.status === "success") {
    let tempContactList = [];
    tempContactList = contactList.map((item) => {
      if (item.contact_list_id === body.ContactListId) {
        let newItem = {
          contact_list_id: body.ContactListId,
          contact_list_full_name: body.ContactListFullName,
          contact_list_email: body.ContactListEmail,
          contact_list_phone: body.ContactListPhone,
          contact_list_type: "",
          contact_list_image: item.contact_list_image,
          contact_list_favorite: body.ContactListFavorite,
        };
        return newItem;
      } else {
        return item;
      }
    });
    setContactList(tempContactList);
  }
  return response;
};

export const deleteUserContactItemDataByIdReact = async ({
  contactListId,
  setReloadContactList,
}) => {
  const body = {
    ContactListId: contactListId,
  };
  const response = await apiRequest(
    "ContactsLists",
    "DeleteUserContactItemDataByIdReact",
    body,
    "POST"
  );
  if (response.status === "success") {
    setReloadContactList(true);
  }
  return response;
};

export const clientCreateMail = async ({ formBody, isViaLink, pathUrl }) => {
  const body = {
    ...formBody,
  };

  const response = await apiRequest(
    "Mails",
    "ReactClientCreateMail",
    body,
    "POST"
  );
  if (response.status === "success") {
    const fullUrl = `${config.baseurl}${pathUrl}upload/${response.data.MailEncryptedId}`;
    window.location.href = fullUrl;
    //window.open(fullUrl, "_blank");
  }
};

export const ImportContactsListFromExcel = async ({
  formBody,
  userId,
  setContactList,
  setContactsQuantity,
}) => {
  const body = {
    ...formBody,
  };

  const response = await apiRequest(
    "ContactsLists",
    "ImportContactsListFromExcel",
    body,
    "POST"
  );
  if (response.status === "success") {
    ReactGetInboxContacts({
      userId: userId,
      currentPage: 1,
      setContactList,
      setContactsQuantity,
    });
  }
};

export const exportContactsListToCsv = async ({ culture }) => {
  const paramenters = {
    culture: culture,
  };
  const response = await apiRequest(
    "ContactsLists",
    "ExportContactsListToCsv",
    paramenters
  );
  if (response.status === "success") {
    let inputFile = response.data;
    let temp = "\ufeff";
    temp += inputFile.FileContent;
    const elementCsv = document.createElement("a");
    const fileCsv = new Blob([temp], {
      type: inputFile.FileContentType,
    });
    elementCsv.href = URL.createObjectURL(fileCsv);
    elementCsv.download = inputFile.FileName + ".csv";
    elementCsv.click();
    //window.open(fullUrl, "_blank");
  }
};

export const exportExampleContactsListToCsv = async ({ culture }) => {
  const paramenters = {
    culture: culture,
  };
  const response = await apiRequest(
    "ContactsLists",
    "ExportExampleContactsListToCsv",
    paramenters
  );
  if (response.status === "success") {
    let inputFile = response.data;
    let temp = "\ufeff";
    temp += inputFile.FileContent;
    const elementCsv = document.createElement("a");
    const fileCsv = new Blob([temp], {
      type: inputFile.FileContentType,
    });
    elementCsv.href = URL.createObjectURL(fileCsv);
    elementCsv.download = inputFile.FileName + ".csv";
    elementCsv.click();
  }
};

export const SearchContactApi = async ({
  searchValue,
  setSearchResult,
  setIconSearch,
  setLoadingSearch,
  setSuccessResultSearch,
  setStartSearch,
  setPrevSearchValue,
}) => {
  const parameters = { searchValue };
  const response = await apiRequest(
    "ContactsLists",
    "SearchContact",
    parameters
  );
  if (response.status === "success") {
    setSuccessResultSearch(true);
    setPrevSearchValue(searchValue);
    if (response.data) {
      if (response.data.ContactsList.length > 0) {
        setSearchResult(response.data.ContactsList);
      } else {
        setSearchResult(null);
      }
    } else {
      setSearchResult(null);
    }
  } else {
    setPrevSearchValue(searchValue);
  }
  setIconSearch("x");
  setLoadingSearch(false);
  setStartSearch(false);
};

export const deleteSelectedContactsApi = async ({
  selectedContactList,
  setReloadContactList,
  setLoadingDeleteContacts,
  setSelectedContactList,
  setSelectAllContacts,
}) => {
  setLoadingDeleteContacts(true);
  const body = {
    ContactListIds: selectedContactList,
  };
  const response = await apiRequest(
    "ContactsLists",
    "DeleteSelectedContacts",
    body,
    "POST"
  );
  if (response.status === "success") {
    setLoadingDeleteContacts(false);
    setReloadContactList(true);
    setSelectedContactList([]);
    setSelectAllContacts(false);
  } else {
    setLoadingDeleteContacts(false);
    setSelectedContactList([]);
    setSelectAllContacts(false);
  }
  return response;
};
